import { render, staticRenderFns } from "./InsightPanel.vue?vue&type=template&id=64629620&scoped=true"
import script from "./InsightPanel.vue?vue&type=script&lang=ts"
export * from "./InsightPanel.vue?vue&type=script&lang=ts"
import style0 from "./InsightPanel.vue?vue&type=style&index=0&id=64629620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64629620",
  null
  
)

export default component.exports